import { OnOffButton } from './OnOffButton';

export class J3PanelBase extends EventTarget {
    name:string = '';
    buttonElem:HTMLElement;
    onOffButton: OnOffButton;
    state: boolean;
    onOffButtonId: string = '';   //ボタン名
    onOffTarget: HTMLElement = null;    //表示・非表示する対象
    overlay:HTMLElement = null;
    syncOverlay:boolean = false;

    constructor(public debugLvl = 0) {
        super();    //'this'を使う前にsuper()を実行する必要がある
    }

    MakeOnOffButtonDOM(buttonElem: HTMLElement, iconOnFile: string = 'onimage', iconOffFile: string = 'offimage', altOn = 'オン', altOff = 'オフ') {
        //ボタン要素の下にOn/Offのサブボタン要素を作成する
        const htmlText1 = '<ul class="list-inline"><li class="btnOff"><figure><button type="button"><img src="' + iconOffFile + '" alt="' + altOff + '"></button></figure></li>';
        const htmlText2 = '<li class="btnOn"><figure><button type="button"><img src="' + iconOnFile + '" alt="' + altOn + '"></button></figure></li></ul>';
        buttonElem.innerHTML = htmlText1 + htmlText2;
    }

    SetButtons(onOffButtonID: string) {
        this.onOffButtonId = onOffButtonID;
        //console.log('Setbuttons targetID', targetID);
        this.onOffButton = new OnOffButton(onOffButtonID, 'off');
        if (this.onOffButton.buttonElem) {
            this.onOffButton.addEventListener("on", () => { this.Show() });
            this.onOffButton.addEventListener("off", () => { this.Hide() });
            this.onOffButton.addEventListener("simple", () => { this.Simple() });
        }
        this.Hide();
    }

    SetOverlay(overlay:string = 'overlay'){
        this.overlay = document.getElementById(overlay);
        if(this.overlay) this.syncOverlay = true;
        //console.log('SetOverlay', this.syncOverlay);
    }

    SetOnOffTarget(target: HTMLElement = null, setClose: boolean = true) {

        if (target) {
            //表示・非表示する対象を設定
            this.onOffTarget = target;
            console.log('SetOnOffTarget', setClose);
            if (setClose) {
                //「閉じる」ボタン
                let btn_target_close: HTMLCollection = null;
                btn_target_close = target.getElementsByClassName('close')[0].getElementsByTagName('button');;
                //console.log('SetOnOffTarget btn_target_close.length', btn_target_close.length);
                if (btn_target_close && btn_target_close.length > 0) {
                    console.log('SetOnOffTarget setEventListener', btn_target_close.length);
                    btn_target_close[0].addEventListener("click", (e: Event) => {
                        console.log('Close Button');
                        this.Hide(true);
                    });
                }
            }
        }
    }

    //オーバーレイの有効・無効（マウス操作のブロック）
    OverlayOn() {
        //console.log("OverlayOn");
        if (this.overlay && this.syncOverlay) this.overlay.style.pointerEvents = 'all';
    }
    OverlayOff() {
        //console.log("OverlayOff")
        if (this.overlay && this.syncOverlay) this.overlay.style.pointerEvents = 'none';
    }


    Simple() {
        let event = new CustomEvent("simple", { detail: { id: this.onOffButtonId } });
        this.dispatchEvent(event);
    }

    Show(dispatchEvent = true) {
        //console.log('Show');
        if (this.debugLvl > 2) console.log("ShowTarget");
        if (this.syncOverlay) this.OverlayOn();
        this.state = true;
        if (dispatchEvent) {
            let event = new CustomEvent("change", { detail: { state: this.state, id: this.onOffButtonId } });
            this.dispatchEvent(event);
        }
        if (this.onOffButton) this.onOffButton.LookOn();
        if (this.onOffTarget) this.onOffTarget.style.display = 'block';
    }
    Hide(dispatchEvent = true, skipSyncOverlay = false) {
        console.log('Hide');
        if (this.syncOverlay && !skipSyncOverlay) this.OverlayOff();
        this.state = false;
        if (dispatchEvent) {
            let event = new CustomEvent("change", { detail: { state: this.state, id: this.onOffButtonId } });
            this.dispatchEvent(event);
        }
        if (this.onOffButton) this.onOffButton.LookOff();
        if (this.onOffTarget) this.onOffTarget.style.display = 'none';
    }
    Toggle(dispatchEvent = true) {
        if (this.debugLvl > 2) console.log("ToggleTarget");
        if (this.state) {
            this.Hide(dispatchEvent);
        } else {
            this.Show(dispatchEvent);
        }
    }

    SetElementDisplay(elem:HTMLElement, prop = 'inline-block'){
        elem.style.display = prop;
    }
    ShowButton(elem:HTMLElement = null){
        if(elem != null) this.buttonElem = elem;
        //console.log('ShowButton');
        this.SetElementDisplay(this.buttonElem, 'inline-block');
    }
    HideButton(elem:HTMLElement = null){
        if(elem != null) this.buttonElem = elem;
        //console.log('HideButton');
        this.SetElementDisplay(this.buttonElem, 'none');
    }
}